// extracted by mini-css-extract-plugin
module.exports = {"inputTextArea":"inputTextArea_inputTextArea__3WA_R","label":"inputTextArea_label__xXtOw","inputDisabled":"inputTextArea_inputDisabled__2TZIO"};